import { useTranslation } from 'react-i18next';
import rulesEN from './importRules-en.md?raw';
import rulesRU from './importRules-ru.md?raw';

export const useRulesContent = () => {
    const { i18n } = useTranslation();

    const rulesContent: { [index: string]: string } = {
        ru: rulesRU,
        en: rulesEN,
    };

    return rulesContent[i18n.resolvedLanguage ?? 'ru'];
};
